import React, { memo } from 'react';
import { Content404 } from '../404';

interface IProps {
    className?: string;
    children: React.ReactNode;
    error: number;
}

export function PageWrap(props: IProps) {
    const { error, children } = props;

    if (typeof error !== 'undefined' && error < 0) {
        return <Content404 error={error}/>;
    }

    return <>{children}</>;
}

export default memo(PageWrap);
